import { takeLatest, put, call, select } from 'redux-saga/effects';
import { SEND_MESSAGES_SAGA } from "../sagaTypes";
import { loaderAction, notificationsFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { PUSH_NOTIFICATION_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/send_messages`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerSendMessages(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('type', args.data.type);
        formData.append('addressees', args.data.addressees);
        formData.append('user', args.data.user);
        formData.append('title', args.data.title);
        formData.append('message', args.data.message);
        formData.append('months', args.data.months);
        formData.append('gender', args.data.gender);
        formData.append('type_workout', args.data.type_workout);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Очищаем форму рассылки
            yield put(notificationsFormAction(PUSH_NOTIFICATION_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherSendMessages() {
    yield takeLatest(SEND_MESSAGES_SAGA, workerSendMessages);
}